import React, { useState } from 'react'
import footerItems from '../../../../specific/constants/footer'
import Column from './Column'
import styles from './columns.module.scss'

export default function Columns() {
  const [showColumn, setShowColumn] = useState('')

  const onClick = (newShowColumn) => {
    if (showColumn === newShowColumn) setShowColumn('')
    else setShowColumn(newShowColumn)
  }

  return (
    <div className={styles.container}>
      <div className={styles.column_wrapper}>
        {footerItems.footer.map((column) => (
          <Column
            key={column.name}
            column={column}
            onClick={onClick}
            showColumn={showColumn}
          />
        ))}
      </div>
    </div>
  )
}
